export default __webpack_public_path__ + "static/k8s-2010538afbda05cf74733a3e87601c1a.png";